import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'arrayValues'
})
export class ArrayValuesPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return Object.values(value);
  }
}
